import classNames from 'classnames';
import React from 'react';
import { pickDomAttrs } from '../_util/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const SkeletonButton = props => {
  const {
    loading = true,
    active = true,
    size = 'm',
    width = 128,
    children,
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style,
    ...restProps
  } = props;
  const baseClassName = "".concat(prefixClass, "-skeletonButton");
  const attrs = pickDomAttrs(restProps);
  if (children === false || children === null || children === undefined) {
    return null;
  }
  if (loading) {
    return /*#__PURE__*/_jsx("span", {
      ...attrs.data,
      className: classNames(className, baseClassName, {
        active
      }, size),
      style: {
        width,
        ...style
      }
    });
  }
  return children;
};
export default SkeletonButton;